import { EditFilled, UserAddOutlined } from '@ant-design/icons';
import { t } from '@framework/i18n';

export function getDinamicButtonProps(
  textBefore?: string,
  textAfter?: string,
  selected?: boolean,
): { buttonText: string; icon: React.ReactNode } {
  // Testo prima della selezione
  const before =
    textBefore && textBefore.trim().length > 0
      ? textBefore
      : t('widgets.candidate.select-button-text', 'Scegli');
  // Testo dopo la selezione
  const after =
    textAfter && textAfter.trim().length > 0
      ? textAfter
      : t('widgets.candidate.change-button-text', 'Cambia');

  const buttonText = selected ? after : before;

  const icon = selected ? <EditFilled /> : <UserAddOutlined />;

  return { buttonText, icon };
}
